/* Copy-to-clipboard for the PDP offer cards.
   One delegated listener for the whole page, so adding cards costs nothing. */
(function () {
  'use strict';

  var RESET_MS = 1800;

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for older Safari and any non-secure context.
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      }
      document.body.removeChild(ta);
    });
  }

  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('.pdp-offer__chip');
    if (!chip) return;

    var code = chip.getAttribute('data-code');
    if (!code) return;

    event.preventDefault();
    if (chip.dataset.copied === 'true') return;

    copy(code).then(function () {
      var label = chip.querySelector('.pdp-offer__chip-label');
      var previous = label ? label.textContent : '';
      chip.dataset.copied = 'true';
      if (label) label.textContent = 'Copied!';
      chip.setAttribute('aria-live', 'polite');

      window.setTimeout(function () {
        chip.dataset.copied = 'false';
        if (label) label.textContent = previous;
      }, RESET_MS);
    }).catch(function () {
      /* Clipboard refused. Leave the code on screen so it can be selected. */
    });
  });

  /* ---- Desktop arrow controls ----
     The track is a plain scroll-snap element, so the arrows only need to move
     its scrollLeft. They stay hidden until the content actually overflows, and
     go disabled at each end rather than disappearing, so the row never jumps. */

  var EDGE = 2; // px tolerance - scrollLeft is fractional on zoomed displays

  function step(track) {
    var card = track.querySelector('.pdp-offer');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function sync(scroller) {
    var track = scroller.querySelector('.pdp-offers__track');
    if (!track) return;

    var overflows = track.scrollWidth - track.clientWidth > EDGE;
    var max = track.scrollWidth - track.clientWidth;

    scroller.querySelectorAll('.pdp-offers__nav').forEach(function (btn) {
      btn.hidden = !overflows;
      btn.disabled = btn.dataset.dir === '-1'
        ? track.scrollLeft <= EDGE
        : track.scrollLeft >= max - EDGE;
    });
  }

  function init() {
    document.querySelectorAll('.pdp-offers__scroller').forEach(function (scroller) {
      var track = scroller.querySelector('.pdp-offers__track');
      if (!track) return;

      sync(scroller);
      track.addEventListener('scroll', function () { sync(scroller); }, { passive: true });

      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(function () { sync(scroller); }).observe(track);
      } else {
        window.addEventListener('resize', function () { sync(scroller); });
      }
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.pdp-offers__nav');
    if (!btn || btn.disabled) return;

    var scroller = btn.closest('.pdp-offers__scroller');
    var track = scroller && scroller.querySelector('.pdp-offers__track');
    if (!track) return;

    event.preventDefault();
    track.scrollBy({ left: step(track) * Number(btn.dataset.dir), behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
